const User2 = ({ size = "120", color = "#5EC394" }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 28 28"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="14" cy="14" r="14" fill={color} />
      <path
        d="M16.0629 13.9109C15.4965 14.2291 14.8474 14.4073 14.1538 14.4073C13.4601 14.4073 12.8111 14.2291 12.2447 13.9109C10.2974 14.6746 8.91016 16.5709 8.91016 18.7918V19.0145C10.3102 20.2491 12.1429 20.9937 14.1538 20.9937C16.1647 20.9937 17.9974 20.2491 19.3974 19.0082V18.7855C19.3974 16.5709 18.0101 14.6746 16.0629 13.9109ZM14.1538 7C12.2447 7 10.6983 8.5464 10.6983 10.4555C10.6983 12.3646 12.2447 13.9109 14.1538 13.9109C16.0629 13.9109 17.6092 12.3646 17.6092 10.4555C17.6029 8.5464 16.0629 7 14.1538 7Z"
        fill="#F8FCFF"
      />
    </svg>
  );
};

export default User2;
